import React, { Component } from "react";

import "./Tooltip.scss";

import Hover from "./Hover";

import dorp from "../Images/dorp.png";

import kleding from "../Images/info-kleding.jpeg";
import dak from "../Images/info-dak.png";
import muren from "../Images/info-muren.JPG";
import palen from "../Images/info-palen.png";

class Tooltip extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.elem = React.createRef();
  }

  handleClick = (e) => {
    e.preventDefault();
    var elements = document.getElementsByClassName('visible');
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove("visible");
    }
    return;
  }

  

  render() {
    return (
      <div className="tooltip">
        <img src={dorp} alt="Boek" onClick={this.handleClick} />
        <div className="orange item1 center">
          <Hover ref={this.elem}
            onHover={
              <>
                <div className="box">
                  Het dak is gemaakt uit bladeren. We hebben speciale technieken
                  om daarmee heel stevige daken te maken. Het zal je niet
                  verbazen dat het al eens kan stortregenen in het regenwoud,
                  maar toch houden onze daken het huis perfect droog. Straf he?
                  Regelmatig moeten delen van het dak wel hersteld of vervangen
                  worden, maar gelukkig is het materiaal daarvoor altijd in de
                  buurt... in het bos!
                  <img src={dak} alt="Dak" />
                </div>
              </>
            }
          >
            <i className="fas fa-plus" />
          </Hover>
        </div>

        <div className="orange item2 center">
          <Hover
            onHover={
              <>
                <div className="box">
                  Mijn huis is inderdaad niet gemaakt uit baksteen, maar uit
                  hout. Dat halen we uit het bos. Ja, daarvoor kappen we af en
                  toe een boom, maar nooit meer dan nodig. We kiezen voor oudere
                  bomen, door hen uit het bos te halen komt er plaats voor
                  jongere exemplaren. Een natuurlijk proces!
                  <img src={muren} alt="Muren" />
                </div>
              </>
            }
          >
            <i className="fas fa-plus" />
          </Hover>
        </div>

        <div className="orange item3 center">
          <Hover
            onHover={
              <>
                <div className="box">
                  De jongens hier dragen geen schoenen. Niet noodzakelijk omdat
                  ze die niet kunnen betalen, maar eerder omdat wij dat
                  traditioneel niet nodig vinden. Onze ouders en voorouders
                  hielden ervan op blote voeten door het bos te lopen, en dat
                  blijven ook wij soms doen. De kleren die ze dragen, komen je
                  misschien wel bekend voor? Tja, die komen dan ook vanuit de
                  stad. Hoe ver die ook is, via enkele wegen of via het water
                  komen bepaalde dingen dus toch tot diep in het woud...
                  <img src={kleding} alt="Kleding" />
                </div>
              </>
            }
          >
            <i className="fas fa-plus" />
          </Hover>
        </div>

        <div className="orange item4 center">
          <Hover
            onHover={
              <>
                <div className="box" style={{maxWidth: '200px'}}>
                  Ja hoor, ook wij gebruiken soms een smartphone! Hoe ver
                  afgelegen we ook zitten, bereik heb je tegenwoordig bijna
                  overal. We hebben zeker niet allemaal een GSM, maar zo kunnen
                  we soms toch ook op Facebook, Instagram, of andere apps. Deze
                  telefoon brachten we mee uit de stad. Af en toe gaan we
                  daarheen, verkopen en ruilen er wat we gemaakt hebben of kopen
                  er kleren en andere dingen die we niet zelf kunnen of willen
                  maken.
                </div>
              </>
            }
          >
            <i className="fas fa-plus" />
          </Hover>
        </div>

        <div className="orange item5 center">
          <Hover
            onHover={
              <>
                <div className="box top">
                  Jullie zagen vast ook dat het huis op palen staat. Zo kan het
                  niet overstromen, en kunnen de dieren minder makkelijk naar
                  binnen.
                  <img src={palen} alt="Palen" />
                </div>
              </>
            }
          >
            <i className="fas fa-plus" />
          </Hover>
        </div>
      </div>
    );
  }
}

export default Tooltip;
